import Axios from 'axios';
import {
  CATEGORY_CREATE_FAIL,
  CATEGORY_CREATE_REQUEST,
  CATEGORY_CREATE_SUCCESS,
  CATEGORY_DELETE_FAIL,
  CATEGORY_DELETE_REQUEST,
  CATEGORY_DELETE_SUCCESS,
  CATEGORY_LIST_FAIL,
  CATEGORY_LIST_REQUEST,
  CATEGORY_LIST_SUCCESS,
  CATEGORY_UPDATE_FAIL,
  CATEGORY_UPDATE_REQUEST,
  CATEGORY_UPDATE_SUCCESS,
} from '../constants/categoryConstants';
import { translateBackendMessage } from '../utils/translateError';

export const listCategories = () => async (dispatch) => {
  dispatch({ type: CATEGORY_LIST_REQUEST });
  try {
    const { data } = await Axios.get('/api/categories');
    dispatch({ type: CATEGORY_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CATEGORY_LIST_FAIL, payload: error.message });
  }
};

export const createCategory = (name, nameEn, namePt) => async (dispatch) => {
  dispatch({ type: CATEGORY_CREATE_REQUEST });
  try {
    const { data } = await Axios.post('/api/categories', { name, nameEn, namePt });
    dispatch({ type: CATEGORY_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CATEGORY_CREATE_FAIL,
      payload: translateBackendMessage(error.response?.data?.message) || error.message,
    });
  }
};

export const reorderCategories = (items) => async () => {
  try {
    await Axios.patch('/api/categories/reorder', { items });
  } catch {
    // best-effort
  }
};

export const updateCategory = (id, name, nameEn, namePt) => async (dispatch) => {
  dispatch({ type: CATEGORY_UPDATE_REQUEST });
  try {
    const { data } = await Axios.put(`/api/categories/${id}`, { name, nameEn, namePt });
    dispatch({ type: CATEGORY_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CATEGORY_UPDATE_FAIL,
      payload: translateBackendMessage(error.response?.data?.message) || error.message,
    });
  }
};

export const deleteCategory = (id) => async (dispatch) => {
  dispatch({ type: CATEGORY_DELETE_REQUEST });
  try {
    await Axios.delete(`/api/categories/${id}`);
    dispatch({ type: CATEGORY_DELETE_SUCCESS });
  } catch (error) {
    dispatch({
      type: CATEGORY_DELETE_FAIL,
      payload: translateBackendMessage(error.response?.data?.message) || error.message,
    });
  }
};
